<template>
  <div style="color:#fff" class="rightBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig" style="height:100%;width:100%;">
        <div class="panel margin--bottom">
          <bar-card :bg="'border10'">
            <v-title :title="graphic.name"
              >{{ graphic.name | ellipsis }}
            </v-title>
            <div class="content">
              <div class="closeDraw">
                <el-button icon="el-icon-close" @click="closeClick"></el-button>
              </div>
              <div class="tabPanel">
                <img class="img" v-lazy="graphic.logo" align="right" />
                <div class="info">{{ graphic.desc }}</div>
              </div>
            </div>
            <v-title>场所展示 </v-title>
            <div class="spContent">
              <div class="imgs flex">
                <img
                  src="~images/video/zwsp.png"
                  v-if="graphic.logo1 == '' && graphic.logo2 == ''"
                />
                <img
                  v-lazy="graphic.logo1"
                  style="height:100%;width:100%;"
                  v-if="graphic.logo1 != '' && graphic.logo2 == ''"
                />
                <div
                  v-if="graphic.logo1 != '' && graphic.logo2 != ''"
                  style="width:100%;height:100%;"
                >
                  <!-- <video width="100%"
                         heigh="90%"
                         class="dddd"
                         id="videos">
                    >
                    <source :src="graphic.logo2"
                            type="video/mp4" />
                  </video> -->
                  <video-player
                    class="video-player vjs-custom-skin videobox"
                    ref="videoPlayerss"
                    :playsinline="true"
                    :options="playerOptions"
                    :events="events"
                    v-if="graphic.logo1 != '' && graphic.logo2 != ''"
                  >
                  </video-player>
                </div>
              </div>
            </div>
          </bar-card>
        </div>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
export default {
  components: {
    videoPlayer
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 9) {
        return value.slice(0, 9) + "...";
      }
      return value;
    }
  },
  data() {
    return {
      activeName: "first",
      list: [],
      weather: [],
      sbList: [],
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src: "http://183.56.231.230:6007/upload/sxyzc.mp4" // url地址
          }
        ],
        poster: require("images/index/map/htzz1.png"), // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      }
    };
  },
  computed: {
    ...mapGetters(["graphic"])
  },
  //   watch: {
  //     graphic(val) {
  //       if (val.logo2 !== '') {
  //         this.$refs.videoPlayerss.player.play()
  //       } else {
  //         this.$refs.videoPlayerss.player.pause()
  //       }
  //     },
  //   },
  mounted() {},
  methods: {
    closeClick() {
      this.$store.dispatch("drawer/setRightComponent", "rightDrawer");
      this.$store.dispatch("drawer/setGraphic", null);
    }
  },
  destroyed() {
    this.$store.dispatch("drawer/setGraphic", null);
  }
};
</script>

<style lang="stylus" scoped>
.panel
  height calc(100% - 8px)
  width 100%
  font-size 0.06rem
.content
  height calc(60% - 43px)
  width calc(100% - 20px)
  padding 0 10px
  position relative
.spContent
  height calc(40% - 43px)
  width calc(100% - 20px)
  padding 0 10px
  position relative
.closeDraw
  position absolute
  right 10px
  top -30px
  .el-button
    background transparent
    color #fff
    font-size 25px
    padding 0
    border 0
    position relative
.warn
  padding 0
  background transparent
  border 0
  color #fff
  font-size 0.18rem
  &:hover
    background transparent
    color #fff
p
  text-indent 28px
  line-height 20px
  font-size 13px
  letter-spacing 2px
.tabPanel
  height calc(100% - 0px)
  width calc(100% - 0px)
  overflow-y auto
  .img
    height 150px
    border-radius 10px
    padding-left 5px
  .info
    text-indent 2em
    line-height 22px
    letter-spacing 2px
    color #fff !important
    width 100%
    height 100%
  &::-webkit-scrollbar
    width 4px
    background-color #00162D
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color #0ff
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
@media (min-width 1700px)
  .el-timeline
    height 80vh
@media (min-height 1400px)
  .content
    height calc(100% - 79px)
  .rightBar
    >>>.side
      width 24% !important
  .closeDraw
    top -60px
    right 20px
    .el-button
      font-size 40px
.imgs
  height calc(100% - 0px)
  width 100%
  justify-content center
.dddd
  width calc(100% - 2px) !important
  height calc(100% - 2px) !important
  object-fit fill
  border 1px #31d5f3 solid
.videobox
  height 100%
  width calc(100% - 0px)
  border-radius 10px
@media (max-width 1280px)
  .content
    height calc(60% - 25px)
  .closeDraw
    top -20px
    .el-button
      font-size 15px
  .tabPanel
    &::-webkit-scrollbar
      width 2px
    .img
      height 75px
      padding-left 3px
    .info
      text-indent 2em
      line-height 16px
      letter-spacing 2px
      font-size 0.08rem
  .spContent
    height calc(40% - 30px)
</style>
